import { useNavigate } from 'react-router-dom';
import { __ } from '@wordpress/i18n';
import ButtonFlat from '../../../ButtonWrapper/components/ButtonFlat';
import StatusIconComponent from '../../../StatusIconComponent';
import { storeSet } from '../../../../store';

const NextActionItem = ({ data, within }) => {
    const navigate = useNavigate();

    const handleVerifica = () => {
        storeSet('cueSheetPanel', 'calendar');
        navigate(`/projects/${data.projectId}`);
    };

    return (
        <li>
            <StatusIconComponent status={data.status}/>
            <div>
                <span>{data.title}</span>
                <span>{__('Entro', 'soundbetween')} {within} {__('giorni', 'soundbetween')}</span>
            </div>
            <ButtonFlat size="sm" onClick={handleVerifica}>{__('Verifica', 'soundbetween')}</ButtonFlat>
        </li>
    );
};

export default NextActionItem;
